var styleDataHash = "6e291f1a";
const injectCss = (() => {
  var css = `@charset "UTF-8";.MW4xp,.ReactModalPortal,.glob_fontElementMap,.qDngE,button{font-family:var(--ricos-font-family,unset)}.dj5W9{display:flex}.YrFf-:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.YrFf-:hover,._2-QVe{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}._2-QVe{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}._4It18 ._2-QVe{box-shadow:none!important}.hkx29{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.hkx29.aHFxG{pointer-events:none}.gR8yX ::selection{background:transparent}.CoiF5{display:none}.qDngE{position:relative}.tlp9K{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{direction:ltr;font-weight:300}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.k8G0-{color:#333;text-decoration:none}.DtCME{display:block}.h5Xqw{position:relative}.GBQNi{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}.GBQNi._50nb-::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}.GBQNi.dGb2E::-webkit-scrollbar-thumb{background-color:transparent}.VdK2p{max-width:max-content!important;min-width:100%}.GBQNi::-webkit-scrollbar{-webkit-appearance:none}.GBQNi::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.GBQNi::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "fontElementMap": "MW4xp",
  "pluginContainer": "qDngE",
  "flex": "dj5W9",
  "isFocusable": "YrFf-",
  "hasFocus": "_2-QVe",
  "dragImageView": "_4It18",
  "overlay": "hkx29",
  "noPointerEventsOnFocus": "aHFxG",
  "hideTextSelection": "gR8yX",
  "hidden": "CoiF5",
  "pluginContainerMobile": "tlp9K",
  "isImage": "k8G0-",
  "anchor": "DtCME",
  "horizontalScrollbarWrapper": "h5Xqw",
  "pluginWithHorizontalScrollbar": "GBQNi",
  "show": "_50nb-",
  "hide": "dGb2E",
  "horizontalScrollbar": "VdK2p"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
